import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsDetailsRoute: InvariantJiraRoute = {
	name: 'classic-software-details',
	path: '/jira/software/c/projects/:projectKey/settings/details',
	exact: true,
};
